export default {
      id: "ic_spor_toto_grey-usage",
      viewBox: "0 0 32 24",
      url: "/" + "images/icons.3.109.2.svg#ic_spor_toto_grey-usage",
      toString: function () {
        return this.url;
      }
    }